var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferIconBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 88,
    viewBox: "0 0 130 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7083 49.0417L91.0417 -3.29167M123.75 22.875C123.75 55.391 97.391 81.75 64.875 81.75C32.3593 81.75 6 55.391 6 22.875C6 -9.64075 32.3593 -36 64.875 -36C97.391 -36 123.75 -9.64075 123.75 22.875ZM97.5833 42.5C97.5833 49.7259 91.7259 55.5833 84.5 55.5833C77.2741 55.5833 71.4167 49.7259 71.4167 42.5C71.4167 35.2741 77.2741 29.4167 84.5 29.4167C91.7259 29.4167 97.5833 35.2741 97.5833 42.5ZM58.3333 3.25C58.3333 10.4759 52.4759 16.3333 45.25 16.3333C38.0243 16.3333 32.1667 10.4759 32.1667 3.25C32.1667 -3.97573 38.0243 -9.83333 45.25 -9.83333C52.4759 -9.83333 58.3333 -3.97573 58.3333 3.25Z",
    stroke: "#7464E4",
    strokeOpacity: 0.04,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferIconBg);
export default __webpack_public_path__ + "static/media/offer-icon-bg.06b44722812ff2c727cad0b184b44ce3.svg";
export { ForwardRef as ReactComponent };